import {Form} from 'react-router'
import classNames from 'classnames'
import {routerPaths} from '@routes'
import {CURRENCY_SYMBOL, type DisplayCurrency} from '@core/billing/displayCurrency'
import {useInterfaceStrings} from '@product/quies/i18n/catalogue'
import {plural} from '@product/quies/i18n/strings'
import {track} from '@core/utils/analytics'
import styles from './PricingItem.module.scss'
import button from '@product/quies/styles/button.module.scss'

type PricingItemProps = {
    title: string
    features: string[]
    price: number
    currency: DisplayCurrency
    token: number
    priceId: string
    emphasis?: boolean
    /** The monthly plan: priced a month, bought by subscription. */
    recurring?: boolean
}

export const PricingItem = ({title, features, price, currency, token, priceId, emphasis = false, recurring = false}: PricingItemProps) => {
    const {lang, t} = useInterfaceStrings()
    return (
        <div className={classNames(styles.pricingItem, {[styles.emphasis]: emphasis})}>
            <div className={styles.pricingHeader}>
                <h3 className={styles.pricingTitle}>{title}</h3>
                <div className={styles.pricingPrice}>
                    <span className={styles.priceAmount}>{CURRENCY_SYMBOL[currency]}{price}</span>
                    <span className={styles.priceToken}>
                        {recurring ? t.pricing.perMonth : plural(t.nav.sessions, lang, token)}
                    </span>
                </div>
            </div>
            <ul className={styles.pricingFeatures}>
                {features.map((feature) => (
                    <li key={`feature-${feature}`}>{feature}</li>
                ))}
            </ul>
            <div className={styles.pricingAction}>
                <Form action={routerPaths['/checkout/:priceId']({priceId})} method="POST">
                    <button
                        type="submit"
                        className={classNames(button.primary, button.block, styles.selectPlan)}
                        onClick={() => track('checkout_started', {price_id: priceId, value: price, currency})}
                    >
                        {recurring ? t.pricing.subscribe : t.pricing.selectPlan}
                    </button>
                </Form>
            </div>
        </div>
    )
}
